import { createRecipe } from './runtime.js';

const skeletonConfig = {"name":"skeleton","defaultVariants":{"variant":"text"},"variantMap":{"radius":["md","smToMd"],"variant":["circle","rect","text"]}}

export const skeleton = /* @__PURE__ */ createRecipe(skeletonConfig)